import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { router } from "@inertiajs/react"
import { IconCalendar } from "@tabler/icons-react"
import { type TicketCard as Card, PRIORITY_BADGE, PRIORITY_LABELS } from "../types"

interface TicketCardProps {
  ticket: Card
  draggable: boolean
}

export function TicketCard({ ticket, draggable }: TicketCardProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: ticket.key,
    disabled: !draggable,
  })

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={cn(
        "bg-card rounded-lg border p-3 text-left shadow-sm",
        draggable && "cursor-grab active:cursor-grabbing",
        isDragging && "opacity-50",
      )}
      {...attributes}
      {...listeners}
    >
      {/* A button rather than a link: the card is a drag handle, and a link would
          start a navigation on every drag. */}
      <button type="button" className="w-full text-left" onClick={() => router.visit(`/tickets/${ticket.key}`)}>
        <div className="mb-2 flex items-start justify-between gap-2">
          <span className="text-sm font-medium leading-snug">{ticket.title}</span>
          {ticket.completed && <Badge variant="outline">Done</Badge>}
        </div>

        <div className="flex flex-wrap items-center gap-1.5">
          <span className="text-muted-foreground font-mono text-xs">{ticket.key}</span>
          <Badge variant={PRIORITY_BADGE[ticket.priority]}>{PRIORITY_LABELS[ticket.priority]}</Badge>
          {ticket.due_on && (
            <span className="text-muted-foreground inline-flex items-center gap-1 text-xs">
              <IconCalendar className="size-3" />
              {ticket.due_on}
            </span>
          )}
          {ticket.assignee && (
            <span className="text-muted-foreground ml-auto truncate text-xs">{ticket.assignee.name}</span>
          )}
        </div>
      </button>
    </div>
  )
}
